import { palette } from './palette';

export const homeStyle = {
  '.MuiCircularProgress-colorPrimary': {
    color: `${palette.brand.main} !important`,
  },
  '.MuiDialog-paper': {
    '& .MuiButton-containedPrimary': {
      borderRadius: '10px !important',
      padding: '16px 20px',
      fontSize: '18px !important',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '-0.36px',

      '&:not(.Mui-disabled)': {
        backgroundColor: `${palette.brand.main} !important`,
        color: `${palette.text.highlight} !important`,

        '&:hover': {
          backgroundColor: `${palette.brand.hover} !important`,
        },
      },
    },

    '& .MuiButton-textPrimary': {
      color: `${palette.brand.main} !important`,
      fontSize: '18px !important',
      fontWeight: 400,
      letterSpacing: '-0.36px',
    },
  },
  '.MuiPickersDay-daySelected': {
    backgroundColor: `${palette.brand.hover} !important`,
    color: `${palette.text.highlight} !important`,
  },
  '.MuiPickersModal-dialogRoot .MuiButton-textPrimary': {
    color: `${palette.brand.main} !important`,
  },
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText
  },

  '& .header-tail-text': {
    color: palette.text.dark,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',
  
        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },
  
        '& .hero-shaped__image': {
          width: '60vw',
          
          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          }
        },
      },
    }
  },

  '.pearlcares-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0
    },

    '& .MuiTypography-root': {
      fontFamily: 'Helvetica, Arial, sans-serif',
    },

    '& .detail-card': {
      backgroundColor: `${palette.brand.surface} !important`,
      border: `1px solid ${palette.border.primary} !important`,
      borderRadius: 12,
    },
    '& .detail-card-service-icon': {
      backgroundColor: `${palette.brand.main} !important`,

      '& img': {
        filter: 'brightness(0) invert(1)',
      },
    },
    '& .detail-card .MuiTypography-h5': {
      fontSize: 18,
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '-0.36px',
      color: palette.text.detail,
    },
    '& .detail-card-duration': {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: '-0.36px',
      color: palette.text.detail,
    },
    '& .detail-card .MuiDivider-root': {
      backgroundColor: palette.border.card,
    },
    '& .detail-card-text': {
      fontSize: 16,
      lineHeight: '22px',
      letterSpacing: '-0.32px',
      color: `${palette.text.detail} !important`,
    },
    '& .map-info-window svg path': {
      stroke: palette.brand.main,
    },
    '& .map-info-window #selected-studio-button svg path': {
      stroke: 'none',
    },

    '& .slot-period-icon path': {
      fill: `${palette.brand.main} !important`,
    },

    '& .slot-calendar-button': {
      backgroundColor: `${palette.background.tertiary} !important`,
      borderColor: `${palette.brand.main} !important`,
      borderRadius: '10px !important',

      '& .MuiSvgIcon-root': {
        color: `${palette.brand.main} !important`,
      },
    },

    '& .timeSlot': {
      borderRadius: '8px !important',
      maxWidth: 'none',
      height: 56,
    },
    '& .timeSlot.MuiButton-outlined': {
      borderColor: `${palette.border.card} !important`,
      color: `${palette.text.detail} !important`,

      '&:hover': {
        backgroundColor: `${palette.brand.main} !important`,
        borderColor: `${palette.brand.main} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },
    '& .timeSlot.MuiButton-contained': {
      backgroundColor: `${palette.brand.main} !important`,
      borderColor: `${palette.brand.main} !important`,
      color: `${palette.text.highlight} !important`,
    },

    '& #choose-studio-button, & .choose-studio-button': {
      backgroundColor: `${palette.brand.main} !important`,
      borderColor: `${palette.brand.main} !important`,
      color: `${palette.text.highlight} !important`,
      borderRadius: '10px !important',

      '&:hover': {
        backgroundColor: `${palette.brand.hover} !important`,
        borderColor: `${palette.brand.hover} !important`,
        color: `${palette.text.highlight} !important`,
      },
    },

    '& .mainContainer .MuiCheckbox-root.Mui-checked': {
      color: `${palette.brand.main} !important`,
    },

    '& .continue-button': {
      borderRadius: '10px !important',
      padding: '16px 20px',
      fontSize: '18px !important',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '-0.36px',

      '&:not(.Mui-disabled)': {
        backgroundColor: `${palette.brand.main} !important`,
        color: `${palette.text.highlight} !important`,

        '&:hover': {
          backgroundColor: `${palette.brand.hover} !important`,
        },
      },
    },

    '& #selected-studio-button, & .selected-studio-button': {
      backgroundColor: `${palette.brand.main} !important`,
      borderColor: `${palette.brand.main} !important`,
      color: `${palette.text.highlight} !important`,
      borderRadius: '10px !important',
    },

    '& .address-suggestion-text-field fieldset': {
      border: `1px solid ${palette.border.field} !important`,
    },
    '& .address-suggestion-text-field:has(.proximityIcon) fieldset': {
      border: 'none !important',
    },
    '& .address-suggestion-text-field:has(.proximityIcon) .address-suggestion-input-field': {
      paddingRight: '0 !important',
    },
    '& .address-suggestion-text-field:has(.proximityIcon) .address-suggestion-input-field input::placeholder': {
      color: `${palette.text.tertiary} !important`,
      opacity: '1 !important',
    },
    '& .address-suggestion-text-field:has(.proximityIcon) .address-suggestion-text-field-label': {
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      border: 0,
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      whiteSpace: 'nowrap',
    },

    '& .mainContainer': {
      backgroundColor: palette.background.paper,
    },

    '& .mainContainer .MuiTypography-h4': {
      fontSize: 32,
      fontWeight: 500,
      lineHeight: '36px',
      letterSpacing: '-1.28px',
      color: palette.text.heading,
    },

    '& .radio-card': {
      display: 'flex',
      alignItems: 'center',
      height: 64,
      minHeight: 64,
      padding: '16px 20px',
      borderColor: `${palette.border.subtle} !important`,

      '& .MuiTypography-root': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.36px',
        color: `${palette.text.normal} !important`,
      },

      '& .MuiRadio-root .MuiIconButton-label': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: '20px !important',
        height: '20px !important',
        borderRadius: '50%',
        border: `1px solid ${palette.border.subtle}`,
      },
      '& .MuiRadio-root .MuiSvgIcon-root': {
        display: 'none !important',
      },
      '& .MuiRadio-root.Mui-checked .MuiIconButton-label': {
        backgroundColor: `${palette.brand.main} !important`,
        borderColor: `${palette.brand.main} !important`,

        '&::after': {
          content: '""',
          display: 'block',
          width: 7.5,
          height: 7.5,
          borderRadius: '50%',
          backgroundColor: palette.text.highlight,
        },
      },

      '&.radio-card-selected': {
        borderColor: `${palette.brand.main} !important`,

        '& .MuiTypography-root': {
          color: `${palette.brand.main} !important`,
        },
      },
    },
    '& .mainContainer': {
      '& .MuiOutlinedInput-root.Mui-focused fieldset, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${palette.brand.main} !important`,
      },

      '& .MuiFormLabel-root.Mui-focused': {
        color: `${palette.brand.main} !important`,
      },
    },

    '& .MuiOutlinedInput-root:has(.select-custom-field)': {
      '& fieldset, & .MuiOutlinedInput-notchedOutline': {
        borderColor: `${palette.border.subtle} !important`,
        borderWidth: '1px !important',
      },

      '&.Mui-focused fieldset, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${palette.brand.main} !important`,
        borderWidth: '1px !important',
      },
    },
    '& .select-field-label': {
      color: `${palette.text.normal} !important`,
    },
    '& .select-field-value': {
      color: `${palette.brand.main} !important`,
    },

    '& .appt-previous-step': {
      color: `${palette.brand.main} !important`,

      '&:hover': {
        color: `${palette.brand.hover} !important`,
      },
    },

    '& .mainContainer': {
      backgroundColor: `${palette.background.paper} !important`,
    },

    '& .cardRoot': {
      borderRadius: 8,
      borderColor: `${palette.border.primary} !important`,

      '& .service-icon-container': {
        width: '56px !important',
        height: '56px !important',
      },

      '& .MuiCardContent-root > .MuiSvgIcon-root': {
        fontSize: '30px !important',
        color: `${palette.icon.tertiary} !important`,
      },

      '& .MuiTypography-colorTextPrimary': {
        color: palette.primary.hover,
      },

      '&:hover': {
        borderColor: `${palette.brand.main} !important`,

        '& .MuiTypography-colorTextPrimary': {
          color: `${palette.primary.hover} !important`,
        },
      },

    },

    '& .mainContainer .MuiAccordionSummary-expandIcon svg': {
      color: `${palette.icon.tertiary} !important`,
    },

    '& .proximityIcon': {
      backgroundColor: `${palette.brand.surface} !important`,

      '& svg': {
        fontSize: '20px !important',
        color: `${palette.brand.main} !important`,
      },
    },

    '& .MuiSwitch-switchBase.Mui-checked': {
      color: palette.primary.main,

      '& + .MuiSwitch-track': {
        backgroundColor: palette.background.default,
        borderColor: palette.primary.main,
      },
    },

    /* Header - Styles */
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section': {
      background: palette.background.border,
      backgroundSize: '100% 2px',
      backgroundRepeat: 'no-repeat',
      backgroundColor: palette.background.main,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.main,
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          maxWidth: 400,
          lineHeight: '55px',

          '@media(min-width: 900px)': {
            lineHeight: '80px',
          },
          '@media(max-width: 900px)': {
            fontSize: 56,
            lineHeight: '64px',
            maxWidth: 350,
            textAlign: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
          },
        },
        '& .hero-subtitle': {
          maxWidth: 550,
          '@media(max-width: 900px)': {
            textAlign: 'center',
            fontSize: 16,
            marginLeft: 'auto',
            marginRight: 'auto',
          },
        },
      },
      '& .section-header__overline-wrapper': {
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        }
      },
      '& .image-wrapper': {
        '@media(max-width: 900px)': {
          display: 'contents',
          padding: '24px 48px 24px 16px',
        },
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
      },
      '@media(max-width: 900px)': {
        '& .section-header__cta-wrapper': {
          marginLeft: 'auto',
          marginRight: 'auto',
        },
        '& .hero-section-grid': {
          justifyContent: 'center',
        },
        '& .section-header__cta-item-wrapper': {
          display: 'flex',
          width: '100%',
          '& .primary-button, .secondary-button': {
            width: '50%',
            marginRight: '10px',
          },
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',

        '& .image': {
          borderRadius: 32,
        },
        '@media(max-width: 1024px)': {
          '& .customImageWrapper': {
            justifyContent: 'center',
          },
        },
        '@media(max-width: 900px)': {
          '& .image, & .customImageWrapper': { 
            display: 'none',
          },
          '& .section-header__title': {
            fontSize: 40,
            fontWeight: 600,
          },
          '& .definition-service-title': {
            fontSize: 20,
          }
        }
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: `url('./images/subscriptionBg.webp') repeat-x top center`,
        backgroundColor: palette.background.footer,
        backgroundSize: 'auto',
      },
      '& .section-alternate': {
        backgroundColor: palette.background.footer,
      },
      '& #pricing-benefit-section': {
        '& .subscription-section': {
          '& .planCard': {
            '& .price-value': {
              fontSize: 40,
              fontWeight: 900,
            },

            '& .customGetStarted': {
              borderStyle: 'solid',
              borderWidth: 1,
            },
            '&:hover': {
              background: palette.text.highlight,
              color: palette.text.primary,

              '& .customGetStarted': {
                backgroundColor: palette.primary.hover,
                borderColor: palette.primary.hover,
                color: palette.text.highlight,
              },

              '& .highlight-divider': {
                backgroundColor: palette.divider,
              },
            }
          },
          '& .section-header__title': {
            marginTop: 100,
          },
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .section-header__title, & .section-header__subtitle, & .subscription-tabs-label, & .summary-subtext, & .summary-text': {
          color: palette.text.highlight,
        },
        '& .savings-summary-link': {
          color: palette.primary.main,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '@media(max-width: 900px)': {
          '& .summary-text': {
            fontSize: 15,
          }
        }
      },
    },

    /* Pricing & Benefits / Addons - Styles */
    '& .addons-wrapper': {
      '& .hero-image': {
        borderRadius: 32,
      }
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-wrapper': {
        '& .how-cover-image': {
          height: 'auto',
        }
      },
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .step-counter': {
        color: palette.text.highlight,
      },
      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
        marginBottom: 0,
        borderBottom: `1px solid ${palette.text.disabled}`,
      },
      '@media(max-width: 1024px)': {
        '& .howitworks-grid > .MuiGrid-item': {
          flexBasis: '100%',
          maxWidth: '100%',
        },
        '& .how-cover-image': {
          display: 'block',
          margin: '0 auto',
        },
      },
      '@media(max-width: 900px)': {
        '& .working-steps-container:not(:last-child)': {
          paddingBottom: 15,
        },
        '& .section-header__title': {
          fontSize: 44,
          fontWeight: 'bold'
        },
        '& .step-title': {
          fontSize: 16,
          fontWeight: 'bold'
        },
        '& .step-content': {
          fontSize: 14,
        },
        '& .howitworks-wrapper': {
          padding: '0 4px',
        },
        '& .MuiGrid-container': {
          flexDirection: 'row !important',
        }
      }
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.main,

      '@media(min-width: 900px)': {
        padding: 72,
      },

      '& .testimonialSection': {
        padding: '40px 32px',
  
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },

        '& .react-multiple-carousel__arrow--left': {
          left: '25%',

          '@media(max-width: 899px)': {
            left: 0,
          },
        },
        '& .react-multiple-carousel__arrow--right': {
          right: '25%',

          '@media(max-width: 899px)': {
            right: 0,
          },
        },
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, & .faq-hero-section, & .faq-contact-wrapper': {
      backgroundColor: palette.background.main,
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,
      
      '& .MuiTypography-root': {
        color: palette.text.primary,
      }
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      backgroundColor: palette.background.main,
      '& .primary-static-button': {
        backgroundColor: palette.primary.main,

        '&:hover': {
          backgroundColor: palette.primary.hover,
          color: palette.text.highlight,
        },
      },
      '& .hero-static-bg': {
        background: palette.background.border,
        backgroundSize: '100% 2px',
        backgroundRepeat: 'no-repeat',
      },
      '@media(max-width: 900px)': {
        '& .section-header__title': {
          textAlign: 'left',
          maxWidth: 350,
          fontSize: 40,
        },
        '& .hero-static-subtitle': {
          fontSize: 16,
          textAlign: 'left',
        },
        '& .hero-button-wrapper': {
          display: 'flex',
          justifyContent: 'left',
        }
      }
    },
    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.icon.primary} !important`,

      '& path': {
        fill: `${palette.icon.primary} !important`,
      },
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },

      '& .hero-home-button': {
        borderWidth: 2,
        borderColor: palette.primary.main,
        backgroundColor: palette.background.default,
        color: palette.text.primary,

        '&:hover': {
          backgroundColor: palette.text.highlight,
          borderColor: palette.primary.hover,
          borderWidth: 2,
        },
      },
      '& .planCard': {
        '& .price-value': {
          fontSize: 40,
          fontWeight: 900,
        },

        '& .customGetStarted': {
          borderStyle: 'solid',
          borderWidth: 1,
        },
        '&:hover': {
          background: palette.text.highlight,
          color: palette.text.primary,

          '& .customGetStarted': {
            backgroundColor: palette.primary.hover,
            borderColor: palette.primary.hover,
            color: palette.text.highlight,
          },

          '& .highlight-divider': {
            backgroundColor: palette.divider,
          },
        }
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      backgroundColor: palette.background.footer,
      background: palette.background.border,
      backgroundSize: '100% 2px',
      backgroundRepeat: 'no-repeat',
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .provider-contact-details, & .contact-card-title, & .contact-card-subtitle, & .provider-contact-link': {
        color: palette.text.highlight,
        fontWeight: 400
      }
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .planCard .MuiButton-root': {
          borderStyle: 'solid',
          borderWidth: 1,
        },
        '& .highlight-button': {
          backgroundColor: palette.primary.hover,
          borderColor: palette.primary.hover,
          color: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },
 
    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      }
    },
    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.text.highlight,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar': {
        background: palette.background.stepper,
        color: palette.text.highlight
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },
  
    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.stepper,
      },
      '& .stepperIconActive': {
        borderColor: palette.background.stepper,
        color: palette.background.stepper,
      },
      '& .stepperIconRoot': {
        borderColor: palette.background.stepper,
        color: palette.background.stepper,
      },
      '& .stepperIconText': {
        fill: palette.text.highlight,
      },
    },

    /* Footer style */
    '& .footer-wrapper': {
      backgroundColor: palette.background.main,
    }
  },
};